import $ from "jquery";
import DataTable from "datatables.net-bs5";

if ( ! DataTable.ext.editorFields ) {
    DataTable.ext.editorFields = {};
}

var Editor = DataTable.Editor;
var _fieldTypes = DataTable.ext.editorFields;
var loaded = false

_fieldTypes.color = {
    create: function ( conf ) {
        var that = this;

        conf._enabled = true;

        // Create the elements to use for the input
        conf._input = $(
            '<input id="'+Editor.safeId( conf.id )+'" type="text" placeholder="" autocomplete="off" class="form-control minicolors-hue">'
        )

        return conf._input;
    },

    get: function ( conf ) {
        return $(conf._input).val();
    },

    set: function ( conf, val ) {
        // if(!val && loaded) {
        //     loaded = true
        //     return
        // }

        if(loaded) {
            $(conf._input).val(val);
            $(conf._input).minicolors('settings', {
                value: val,
                control:  'wheel',
                position: 'bottom left',
                swatches: [
                    {name: 'Groen', color: '#02BC77'},
                    {name: 'Blauw', color: '#28c3d7'},
                    {name: 'Geel', color: '#FFD950'},
                    {name: 'Grijs', color: '#858380'},
                    {name: 'Rood', color: '#d9534f'},
                    {name: 'Zwart', color: '#181c21'},
                ],
            });
            return
        }


        loaded = true

        setTimeout(function() {

            $(conf._input).minicolors({
                control:  'wheel',
                position: 'bottom left',
                swatches: [
                    {name: 'Groen', color: '#02BC77'},
                    {name: 'Blauw', color: '#28c3d7'},
                    {name: 'Geel', color: '#FFD950'},
                    {name: 'Grijs', color: '#858380'},
                    {name: 'Rood', color: '#d9534f'},
                    {name: 'Zwart', color: '#181c21'},
                ],
                defaultValue: val,
            });
        }, 300)

    },

    enable: function ( conf ) {
        conf._enabled = true;
        $(conf._input).removeClass( 'disabled' );
    },

    disable: function ( conf ) {
        conf._enabled = false;
        $(conf._input).addClass( 'disabled' );
    }
};
